import {
    TB_INFO_LOADED, TB_INFO_LOADING
} from "../../actions/actionTypes";

const initialState = {
    tbInfoData: [],
    capCampaignNamesLoading: false,
};

export default function (state = initialState, action = {}) {
    switch (action.type) {
        case TB_INFO_LOADING:
            return {
                ...state,
                loading: true
            };
        case TB_INFO_LOADED:
            return {
                ...state,
                tbInfoData: action.payload,
                loading: false
            };
        default:
            return state;
    }
}